module.exports = __webpack_public_path__ + "static/img/zhangdaizhao.99212fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/zhangdaizhao.png
// module id = GCvt
// module chunks = 1